module.exports = __webpack_public_path__ + "static/media/mrtodo.5d3c7016.svg";